<style scoped lang="sass">
::v-deep
  .btn
    padding: 0
    width: 388PX
    height: 275PX

  .take
    width: 510PX

    .title
      margin: 21PX 0

    .content
      margin-bottom: 30PX

::v-deep
  .mu-dialog-body
    padding: 0
    height: 100%

.dialog_box
  display: flex
  flex-direction: column
  justify-content: space-between
  padding: 30PX 25PX 25PX 26PX
  height: 100%

.button
  width: 100%
  height: 56PX
  font-size: 15PX

.dialog_container
  display: flex
  flex-direction: column
  justify-content: space-between

  .icon
    width: 67PX
    margin: 0 auto
    height: 67PX

.title
  margin-top: 15PX
  margin-bottom: 10PX
  font-size: 18PX
  line-height: 1
  text-align: center
  color: var(--menu-primary-text-colour)

.content
  line-height: 17PX
  font-size: 14PX
  text-align: center
  color: var(--menu-primary-text-colour)

.second
  margin-top: 20PX

::v-deep
  .van-popup
    display: flex
    flex-direction: column
    padding: 10PX 10PX 0 10PX
    width: 283PX

  .van-button--primary
    background: var(--menu-primary-background-colour)
    border: none
    border-radius: 4PX !important

</style>

<template lang="pug">

mu-dialog.tab_dialog_container(
  :open="visible"
  :showCloseIcon="false"
  :position="'center'"
  :dialog-class="isTakeNote ? 'take' : 'btn'"
)
  .dialog_box
    .dialog_container
      img.icon(:src="icon")
      .title.b {{ title }}
      .content.o75 {{ newContent }}
      .content.second.o75(v-if="secContent") {{ secContent }}
    van-button.button.b(type="primary" @click="clickHandler") {{ buttonText }}
</template>

<script>
export default {
  name: 'PcTabMessageDialog',
  props: {
    insertStr: String, // If a string needs to be inserted at a certain position in content, this variable will pass the content to be inserted   // 如果 content 中某个位置需要插入字符串，那么此变量就传递要插入的内容
    icon: [Object, String],
    title: String,
    content: String,
    buttonText: String,
    secContent: String,
    top: String
  },

  computed: {
    newContent() {
      if (this.insertStr) {
        return this.content.replace('$insertStr', this.insertStr)
      }
      return this.content
    },

    isTakeNote() {
      return this.title === 'Take note!'
    }
  },

  data() {
    return {
      visible: false,
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    hide() {
      this.visible = false
    },

    clickHandler() {
      this.visible = false
      this.$emit('click')
    },
  }
}
</script>
